import { AuthorizedData } from "../models/dto/arrival/authorized-responsable/authorized-data";
import { AuthorizedDataPhoto } from "../models/dto/arrival/gates-monitoring/authorization-data-photo";
import { ImageType } from "../models/enum/arrival/authorized-responsable/image-type.enum";
import { TypeUser } from "../models/enum/arrival/authorized-responsable/type-image-user";

export const buildShowImageDialog = (authorizationDataPicture: AuthorizedData, typeUser: TypeUser) : AuthorizedDataPhoto => {
  return {
    photo: authorizationDataPicture.photo && authorizationDataPicture.photo.paths[0] !== ''  ? authorizationDataPicture.photo.paths : [`https://ui-avatars.com/api/?size=512&name=${authorizationDataPicture.name}`],
    typePicture: typeUser === TypeUser.RESPONSIBLE || authorizationDataPicture.photo===null ? ImageType.PROFILE : authorizationDataPicture.photo.type,
    typeUser: typeUser
  }
}
